import { render, staticRenderFns } from "./SamTextList.vue?vue&type=template&id=76e71468&scoped=true&shadow"
import script from "./SamTextList.vue?vue&type=script&lang=js&shadow"
export * from "./SamTextList.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamTextList.vue?vue&type=style&index=0&id=76e71468&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "76e71468",
  null
  ,true
)

export default component.exports